import React, { useEffect } from "react";
import useProvisioningStatus from "./useProvisioningStatus";
import { ProvisioningStatus } from "./ProvisioningStatus.jsx";
import { useNavigate, useParams } from "react-router-dom";
import { message, Spin } from "antd";

function IAC() {
  // Get all data from the hook
  const {
    data,
    error,
    progress,
    elapsed,
    amplifyData,
    amplifyError,
    amplifyProgress,
    handleFetchData,
  } = useProvisioningStatus();

  const { id:executionId=null } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    handleFetchData({pipelineExecutionId:executionId});
  }, []);

  if(!executionId) return <div>No execution ID provided.</div>
  if(!data && !error) return <Spin spinning={true} fullscreen />

  return (
    <ProvisioningStatus
      data={data}
      error={error}
      progress={progress}
      elapsed={elapsed}
      amplifyData={amplifyData}
      amplifyError={amplifyError}
      amplifyProgress={amplifyProgress}
      onBack={() => window.history.back()}
      onCompleted={() => {
        message.success("Deployment completed");
        navigate("/manage-LandingPages");
      }}
    />
  );
}

export { IAC };
